import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/data-empty.png'


const _hoisted_1 = { class: "flex flex-col items-center py-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, " Belum ada Trayek Terdaftar ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal text-center mb-5 w-full md:w-1/2" }, " Masih belum ada trayek yang terdaftar pada trayek ini. Tambah trayek pertamamu dengan klik Tambah trayek di bawah ", -1)
const _hoisted_5 = { class: "text-center w-full md:w-1/3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary font-bold text-sm" }, "+ Tambah Trayek", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Card, { class: "card-no-shadow wrap-hjp-data-list" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              class: "w-full extra-submit-button mb-2 sm:mb-0 flex gap-4",
              onClick: _ctx.showForm
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}